export default "__VITE_PUBLIC_ASSET__129080ad__"